import Assistant from "./Assistant/Assistant";
import Download from "./Download/Download";
import Globe from "./Globe/Globe";
import Icon from "./Icon";
import KrossKast from "./KrossKast/KrossKast";
import MakeActive from "./MakeActive/MakeActive";
import Player from "./Player/Player";
import SendToProd from "./SendToProd/SendToProd";
import Trash from "./Trash/Trash";

export {
  Assistant,
  Download,
  Globe,
  Icon,
  KrossKast,
  MakeActive,
  Player,
  SendToProd,
  Trash,
};

export default Icon;
